// ContactForm Component

/* eslint indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import validator from 'validator'

import app from '../../../app.jsx'
import countries from '../../../lib/countries.jsx'
import usastates from '../../../lib/usastates.jsx'
import Input from '../../../common/form/input/input.jsx'
import Select from '../../../common/form/select/select.jsx'
import FormButton from '../../../common/form/button/button.jsx'
import Tab from '../../../common/layout/tab/tab.jsx'
import TabPanel from '../../../common/layout/tab_panel/tab_panel.jsx'

import ContactFormHeader from '../../common/contact_formheader/contact_formheader.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import util from '../../../lib/util.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import FinanceTab from './finance_tab.jsx'
import ContactPersonsTab from './contact_persons_tab.jsx'
import currency from '../../../lib/currency.jsx'
import isEuropeanCountry from '../../../../shared/util/isEuropeanCountry'
import { isVatSupportedInCountry } from '../../../../shared/util/vat'

import { Grid, Button, Icon, ThemeProvider, lightTheme } from '@rodeo-dev/legos'
import { trimObjValues } from '../../../lib/objects.js'

class ContactForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      imageAvatar: null,
      imageAvatarUrl: null,
      imageDeleted: false,
      showEmailError: false
    }

    this.data = {
      items: [
        {
          label: 'contact.view.defaultLabelDirector',
          value: 'contact.view.defaultLabelCost'
        },
        {
          label: 'contact.view.defaultLabelDesign',
          value: 'contact.view.defaultLabelCost'
        }
      ],
      contact: _.cloneDeep(this.props.contact),
      isContactPersonsFormValid: true,
      types: [
        { label: 'contact.view.typeOffice', value: 'Office' },
        { label: 'contact.view.typeEstimate', value: 'Estimate' },
        { label: 'contact.view.typeInvoice', value: 'Invoice' },
        { label: 'contact.view.typePO', value: 'PO' },
        { label: 'contact.view.typeOther', value: 'Other' }
      ],
      languages: [
        { label: 'user.signup.optionNederlands', value: 'NL' },
        { label: 'user.signup.optionEnglish', value: 'EN' },
        { label: 'user.signup.optionDeutsch', value: 'DE' }
      ],
      unUsedTypes: ['Office', 'Estimate', 'Invoice', 'PO', 'Other'],
      usedTypes: []
    }

    this._references = {
      formHeader: React.createRef(),
      inputCompany: React.createRef(),
      inputEmail: React.createRef(),
      inputWebsite: React.createRef(),
      inputVat: React.createRef()
    }

    if (props.teamCountry && props.teamCountry === 'US') {
      this.data.languages.push({
        label: 'user.signup.optionUnitedstates',
        value: 'US'
      })
    }

    this._bFocusRateCard = false
    this._validateStep = false
    this.bVatValidate = false
  }

  static get propTypes () {
    return {
      contact: PropTypes.object,
      onSubmit: PropTypes.func,
      showRates: PropTypes.bool,
      onVatValidate: PropTypes.func,
      rateCards: PropTypes.array,
      showHeader: PropTypes.bool,
      teamPaymentDays: PropTypes.number,
      prefixCurrency: PropTypes.string,
      teamCountry: PropTypes.string,
      isEditMode: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      contact: null,
      onSubmit: null,
      showRates: false,
      onVatValidate: PropTypes.func,
      rateCards: [],
      showHeader: true,
      teamPaymentDays: 0,
      prefixCurrency: '',
      teamCountry: '',
      isEditMode: false
    }
  }

  componentDidUpdate (prevProps, prevState) {
    this._bFocusRateCard = false
    const currStep = this.state.stepIndex
    if (prevState.stepIndex !== currStep && this._validateStep) {
      this._validateStep = false
      this.validate(false)
    }
  }

  render () {
    const imageUrl = this.state.imageAvatar
      ? this.state.imageAvatarUrl
      : this.state.imageDeleted
      ? ''
      : this.data.contact.imageUrl
    const setIndex = this.state.stepIndex
    const paymentDays =
      this.data.contact.paymentDays !== -1
        ? this.data.contact.paymentDays
        : this.props.teamPaymentDays

    const formContent = (
      <div className='contact-form'>
        <Tab onChange={this._onChangeTab.bind(this)}>
          <TabPanel title='contact.form.general' active={setIndex === 0}>
            {this._renderGeneralForm()}
          </TabPanel>
          <TabPanel title='contact.form.contactPersons' active={setIndex === 1}>
            <ContactPersonsTab
              contactPersons={this.data.contact.contactPersons}
              onSaveContactPersons={this._onSaveContactPersons.bind(this)}
            />
          </TabPanel>
          <TabPanel title='contact.form.finance' active={setIndex === 2}>
            <FinanceTab
              defaultRates={{
                rate: this.data.contact.rate,
                rateMarkup:
                  this.data.contact.rateMarkup ||
                  this.data.contact.rateMarkup === 0
                    ? this.data.contact.rateMarkup
                    : undefined,
                paymentDays
              }}
              contactRateCards={this.data.contact.rateCards}
              globalRateCards={this.props.rateCards.map(item => ({
                ...item,
                amount: currency.format(item.amount),
                markupPercentage: currency.formatForInputNumber(
                  item.markupPercentage
                )
              }))}
              currencySymbol={this.props.prefixCurrency}
              onRateCardsSave={this._onSaveRateCards.bind(this)}
              onDefaultsSave={this._onSaveClientDefaultRates.bind(this)}
            />
          </TabPanel>
        </Tab>
      </div>
    )

    if (!this.props.showHeader) {
      return formContent
    }

    return (
      <form
        className='form'
        method='post'
        noValidate
        action='#'
        onSubmit={this._onFormSubmit.bind(this)}
      >
        <ContactFormHeader
          imageUrl={imageUrl}
          companyName={this.data.contact.company}
          onUploadSuccess={this._onUploadSuccess.bind(this)}
          ref={this._references.formHeader}
          onDeleteImage={this._onUploadDelete.bind(this)}
          activeTab={this.state.activeTab}
        />
        {formContent}
      </form>
    )
  }

  _onSaveRateCards (updatedRateCards, ratesType) {
    const contact = this.data.contact
    const newRateCards = [
      ...contact.rateCards.filter(({ type }) => type !== ratesType),
      ...updatedRateCards.map(item => ({
        name: item.name,
        amount: item.amount,
        markupPercentage: item.markupPercentage,
        type: ratesType
      }))
    ]
    this.data.contact.rateCards = newRateCards
    this._updateContactRates({ ...contact, rateCards: newRateCards })
  }

  _onSaveClientDefaultRates (defaultRates) {
    const contact = this.data.contact
    Object.keys(defaultRates).forEach(key => {
      contact[key] = defaultRates[key]
      this.data.contact[key] = defaultRates[key]
    })
    this._updateContactRates(contact)
  }

  _updateContactRates (contact) {
    const contactData = util.removeObjectKeys(_.cloneDeep(contact), [
      'id',
      'imageUrl'
    ])

    app
      .service('/api/contact')
      .update(contact.id, contactData)
      .then(() => {
        this._references.formHeader.current.showMessage(
          IntlUtil.convertMessage('contact.form.rateCardsSaved'),
          null,
          true
        )
      })
      .catch(() => {
        this._references.formHeader.current.showMessage(
          IntlUtil.convertMessage('contact.form.rateCardsSavedError'),
          IntlUtil.convertMessage('contact.form.rateCardsSavedErrorInfo'),
          false
        )
      })
  }

  _updateContactContactPersons (contact) {
    app
      .service('/api/contact')
      .patch(contact.id, { contactPersons: contact.contactPersons })
      .then(() => {
        this._references.formHeader.current.showMessage(
          IntlUtil.convertMessage('contact.form.msgSuccessTitle'),
          null,
          true
        )
      })
      .catch(() => {
        this._references.formHeader.current.showMessage(
          IntlUtil.convertMessage('contact.form.msgErrorTitle'),
          IntlUtil.convertMessage('contact.form.msgErrorInfo'),
          false
        )
      })
  }

  /* Event handlers */
  _onChangeTab (index) {
    const tabNames = ['general', 'contactPersons', 'finance']
    if (this.state.stepIndex !== index) {
      this.setState({
        stepIndex: index,
        activeTab: tabNames[index],
        dataDate: new Date()
      })
    }
  }

  _onChangeInput (name, value) {
    this.data.contact[name] = value
  }

  _onChangeAdddress (addr, name, value) {
    this._updateAddress(addr, name, value)
  }

  _onChangePdfLanguage (name, value) {
    this.data.contact[name] = value
    this.setState({ dataDate: new Date() })
  }

  _updateAddress (addr, name, value) {
    if (name === 'country' && value !== 'US') {
      addr.state = ''
      addr.country = value
    } else {
      addr[name] = value
    }
    const country =
      this.data.contact.addresses.length > 0
        ? this.data.contact.addresses[0].country
        : this.props.teamCountry
    this.bVatValidate = util.isValidVatNumber(country)
    this.setState({ dataDate: new Date() })
  }

  _onDelete (addr, idx, _ev) {
    this.data.contact.addresses = _.remove(
      this.data.contact.addresses,
      (address, addrIdx) => {
        return addrIdx !== idx
      }
    )
    this.setState({ dataDate: new Date() })
  }

  _validateAndUpdateContacts () {
    const persons = []
    if (this.data.contact.contactPersons) {
      this.data.contact.contactPersons.map(person => {
        const p = trimObjValues(person)

        if (p.name || p.email || p.phone || p.department) {
          persons.push(p)
        }
      })
    }

    this.data.contact.contactPersons = persons
  }

  getContact () {
    if (this.data.contact.addresses.length <= 0) {
      this.data.contact.addresses.push({
        type: this._getDefaultAddressType(),
        street: '',
        streetNumber: '',
        postcode: '',
        city: '',
        state: '',
        country: this.props.teamCountry
      })
    }

    if (this.data.contact.contactPersons.length <= 0) {
      this.data.contact.contactPersons.push({
        name: '',
        email: '',
        phone: ''
      })
    }

    return this.data.contact
  }

  getValueAsWebsite (value) {
    let val = value
    if (
      val &&
      val.indexOf('http://') === -1 &&
      val.indexOf('https://') === -1
    ) {
      val = `http://${val}`
    }

    return val
  }

  validate (bShowError) {
    let errorCount = 0
    let field = ''
    if (
      !this.data.contact.company ||
      validator.isEmpty(this.data.contact.company.toString().trim())
    ) {
      errorCount++
      field = IntlUtil.convertMessage('contact.form.msgCompanyError')
      this._validateStep = true
    } else if (!this.validateEmail()
    ) {
      errorCount++
      field = IntlUtil.convertMessage('contact.form.msgEmailError')
      this._validateStep = true
    } else if (
      this.data.contact.website &&
      !validator.isURL(this.getValueAsWebsite(this.data.contact.website.trim()))
    ) {
      errorCount++
      field = IntlUtil.convertMessage('contact.form.msgWebsiteError')
      this._validateStep = true
    }

    if (errorCount && bShowError) {
      this.setState({ stepIndex: 0 })
      this._references.formHeader.current.showMessage(
        IntlUtil.convertMessage('contact.form.msgErrorTitle'),
        field,
        false
      )
    }

    return errorCount === 0
  }

  validateEmail () {
    const falsyIsValid = x => !x
    const emailIsValid = x => validator.isEmail(x.toString().trim())
    const email = this.data.contact.email
    const emailValid = falsyIsValid(email) || emailIsValid(email)
    this.setState({ showEmailError: !emailValid })
    return emailValid
  }

  _onFormSubmit (ev) {
    ev.preventDefault()
    const website =
    this.data.contact && this.data.contact.website
      ? this.data.contact.website.trim()
      : ''
  if (
    website &&
    website.indexOf('http://') === -1 &&
    website.indexOf('https://') === -1
  ) {
    this.data.contact.website = `http://${website}`
  }

  if (this.data.contact.addresses.length <= 0) {
    this.data.contact.addresses.push({
      type: this._getDefaultAddressType(),
      street: '',
      streetNumber: '',
      postcode: '',
      city: '',
      state: '',
      country: this.props.teamCountry
    })
  }

  if (this.validate(true) && this.props.onSubmit) {
    this.props.onSubmit(
      this.data.contact,
      this.state.imageAvatar,
      this.state.imageDeleted,
      (errTitle, errInfo, bSuccess) => {
        if (this.props.showHeader) {
          this._references.formHeader.current.showMessage(
            errTitle,
            errInfo,
            bSuccess
          )
        }
      }
    )
  }
  }

  refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onSaveContactPersons (contactPersons) {
    const { contact } = this.data
    contact.contactPersons = contactPersons
    this._validateAndUpdateContacts()
    this._updateContactContactPersons(contact)
  }

  _onUploadSuccess (file, message) {
    this.setState({
      imageAvatar: message.id,
      imageDeleted: false,
      imageAvatarUrl: message.url
    })
  }

  _onUploadDelete () {
    this.data.contact.image = null

    if (this.state.imageAvatar) {
      this.setState({
        imageDeleted: true,
        imageAvatar: null,
        imageAvatarUrl: null
      })
    } else {
      this.setState({ imageDeleted: true, dataDate: new Date() })
    }
  }

  _onBlurVatNumber () {
    if (this.props.onVatValidate) {
      const country =
        this.data.contact.addresses.length > 0
          ? this.data.contact.addresses[0].country
          : this.props.teamCountry
      this.props.onVatValidate(country, this.data.contact.vatNo, bValid => {
        if (!bValid && this.props.showHeader) {
          this._references.formHeader.current.showMessage(
            IntlUtil.convertMessage('contact.form.msgErrorTitle'),
            IntlUtil.convertMessage('contact.form.msgVatError'),
            false
          )
        }
      })
    }
  }

  /* Private functions */
  _renderGeneralForm () {
    const contact = this.data.contact
    contact.pdfLanguage = contact.pdfLanguage
      ? contact.pdfLanguage
      : this.props.teamCountry === 'UK'
      ? 'EN'
      : this.props.teamCountry

    return (
      <div className='form-layout'>
        <div className='layoutcol layoutcol2'>
          <div className='formsection'>
            <div className='formheader formheader_hasborder'>
              <h3>
                <IntlMessage ident='contact.form.information' />
              </h3>
            </div>
            <div className='formrow'>
              {this.props.showHeader && (
                <div className='formcol'>
                  <Input
                    type='text'
                    name='company'
                    value={contact.company}
                    label='contact.form.companyNamePlaceholder'
                    styleDotted
                    size={10}
                    maxLength={100}
                    ref={this._references.inputCompany}
                    prefixIcon='view-address'
                    validations={['required']}
                    onChange={this._onChangeInput.bind(this, 'company')}
                  />
                </div>
              )}
            </div>
            <div className='formrow'>
              <div className='formcol'>
                <Input
                  type='text'
                  name='email'
                  value={contact.email}
                  label='contact.form.emailPlaceholder'
                  size={10}
                  maxLength={100}
                  prefixIcon='form-mail'
                  styleDotted
                  ref={this._references.inputEmail}
                  validations={['email']}
                  onChange={this._onChangeInput.bind(this, 'email')}
                  error={this.state.showEmailError}
                  errorMsg={IntlUtil.convertMessage('contact.form.msgEmailError')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formcol'>
                <Input
                  type='text'
                  name='phone'
                  value={contact.phone}
                  label='contact.form.telephonePlaceholder'
                  size={10}
                  maxLength={16}
                  prefixIcon='form-call'
                  styleDotted
                  validations={['intlphone']}
                  onChange={this._onChangeInput.bind(this, 'phone')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formcol'>
                <Input
                  type='text'
                  name='mobile'
                  value={contact.mobile}
                  label='contact.form.mobilePlaceholder'
                  size={10}
                  maxLength={16}
                  prefixIcon='form-mobile'
                  styleDotted
                  validations={['intlphone']}
                  onChange={this._onChangeInput.bind(this, 'mobile')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formcol'>
                <Input
                  type='text'
                  name='website'
                  value={contact.website}
                  label='contact.form.websitePlaceholder'
                  size={10}
                  maxLength={100}
                  prefixIcon='form-website'
                  styleDotted
                  ref={this._references.inputWebsite}
                  validations={['website']}
                  onChange={this._onChangeInput.bind(this, 'website')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formcol'>
                <Select
                  options={this.data.languages}
                  name='state'
                  className='form-dropdown'
                  multilingualOptions
                  label='contact.form.pdfLangPlaceholder'
                  value={contact.pdfLanguage}
                  styleDotted
                  onChange={this._onChangePdfLanguage.bind(this, 'pdfLanguage')}
                  disabled={this.props.teamCountry === 'US'}
                />
              </div>
            </div>
          </div>
          {isVatSupportedInCountry(this.props.teamCountry) && (
            <div className='formsection'>
              <div className='formheader formheader_hasborder'>
                <h3>
                  <IntlMessage ident='contact.form.vat' />
                </h3>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='vatNo'
                    size={10}
                    maxLength={100}
                    label='contact.form.vatNumberPlaceholder'
                    value={contact.vatNo}
                    styleDotted
                    validations={[this.bVatValidate ? 'required' : '']}
                    onBlur={this._onBlurVatNumber.bind(this)}
                    multilingual={false}
                    ref={this._references.inputVat}
                    onChange={this._onChangeInput.bind(this, 'vatNo')}
                  />
                  <div className='vat-information'>
                    <div>
                      <IntlMessage ident='contact.form.messageVatNumber' />
                    </div>
                    <div className='subtext'>
                      <IntlMessage ident='contact.form.checkVatNumber' />
                      <a
                        href='http://ec.europa.eu/taxation_customs/vies/'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <IntlMessage ident='contact.form.vatURL' />
                      </a>
                      <i className='icon icon-info-link' />
                    </div>
                  </div>
                  <div className='layoutcol layoutcol2'>
                    <div className='formsection save' />
                    <ThemeProvider theme={lightTheme}>
                      <Grid container justify='flex-end'>
                        <Button
                          color='secondary'
                          onClick={this._onFormSubmit.bind(this)}
                          disabled={false}
                          size='small'
                          startIcon={<Icon icon='check' size='small' color='inherit' />}
                        >
                          {IntlUtil.convertMessage('common.form.save')}
                        </Button>
                      </Grid>
                    </ThemeProvider>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className='layoutcol layoutcol2'>
          <div className='formsection'>
            <div className='formheader formheader_hasborder'>
              <h3>
                <IntlMessage ident='contact.form.address' />
              </h3>
            </div>
            {this._renderAddress()}

            <ThemeProvider theme={lightTheme}>
              <Grid container justify='space-between' alignItems='flex-start'>
                {this.data.contact.addresses.length < 5 && (
                  <Grid item>
                    <FormButton
                      title='contact.form.actionAddAddress'
                      secondary
                      onClick={this._onAddAddress.bind(this)}
                    />
                  </Grid>
                )}
                {!isEuropeanCountry(this.props.teamCountry) && (
                  <Grid item>
                    <Button
                      color='secondary'
                      onClick={this._onFormSubmit.bind(this)}
                      disabled={false}
                      size='small'
                      startIcon={<Icon icon='check' size='small' color='inherit' />}
                    >
                      {IntlUtil.convertMessage('common.form.save')}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </ThemeProvider>
          </div>
        </div>
      </div>
    )
  }

  _getDefaultAddressType () {
    const options = _.cloneDeep(this.data.types)

    if (this.data.contact.addresses.length > 0) {
      this.data.contact.addresses.map(address => {
        _.remove(options, opt => opt.value === address.type)
      })
    }

    return options[0].value
  }

  _getAddressTypes (currType) {
    const options = []
    const unUsedTypes = _.cloneDeep(this.data.unUsedTypes)

    this.data.usedTypes.map(usedType => {
      _.remove(unUsedTypes, unUsedType => unUsedType === usedType)
    })

    unUsedTypes.push(currType)
    unUsedTypes.map(unUsedType => {
      const typeObj = _.find(this.data.types, type => type.value === unUsedType)
      options.push(typeObj)
    })

    return options
  }

  _renderAddress () {
    const addressLen = this.data.contact.addresses
      ? this.data.contact.addresses.length
      : 0

    this.data.usedTypes = []
    this.data.contact.addresses.map(address => {
      const usedType = _.find(
        this.data.usedTypes,
        usedType => usedType === address.type
      )

      if (!usedType) {
        this.data.usedTypes.push(address.type)
      }
    })

    if (addressLen > 0) {
      return this.data.contact.addresses.map((addressObj, idx) => {
        const types = this._getAddressTypes(addressObj.type)
        return (
          <div className='formsection addresssection' key={idx}>
            <div className='formrow'>
              <div className='formcol formcol_type'>
                <Select
                  options={types}
                  name='type'
                  icon='view-location'
                  label='contact.form.typePlaceholder'
                  multilingualOptions
                  className='form-dropdown'
                  onChange={this._onChangeAdddress.bind(
                    this,
                    addressObj,
                    'type'
                  )}
                  value={addressObj.type}
                />
                <IconButton
                  icon='common-item-delete'
                  size='normal'
                  className='contact'
                  onClick={this._onDelete.bind(this, addressObj, idx)}
                  canHover={false}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formcol'>
                <Input
                  type='text'
                  name='street'
                  size={10}
                  maxLength={100}
                  label='contact.form.streetPlaceholder'
                  value={addressObj.street}
                  styleDotted
                  onChange={this._onChangeAdddress.bind(
                    this,
                    addressObj,
                    'street'
                  )}
                />
              </div>
            </div>
            <div className='formrow formrow__small'>
              <div className='formcol2'>
                <Input
                  type='text'
                  name='postcode'
                  size={10}
                  maxLength={24}
                  label='contact.form.zipCodePlaceholder'
                  value={addressObj.postcode}
                  styleDotted
                  onChange={this._onChangeAdddress.bind(
                    this,
                    addressObj,
                    'postcode'
                  )}
                />
              </div>
              <div className='formcol2'>
                {addressObj.country === 'US' ? (
                  <Select
                    options={usastates}
                    name='state'
                    className='form-dropdown'
                    label='contact.form.statePlaceholder'
                    value={addressObj.state}
                    styleDotted
                    onChange={this._onChangeAdddress.bind(
                      this,
                      addressObj,
                      'state'
                    )}
                  />
                ) : (
                  <Input
                    type='text'
                    name='city'
                    size={10}
                    maxLength={100}
                    label='contact.form.cityPlaceholder'
                    value={addressObj.city}
                    styleDotted
                    onChange={this._onChangeAdddress.bind(
                      this,
                      addressObj,
                      'city'
                    )}
                  />
                )}
              </div>
            </div>
            {addressObj.country === 'US' && (
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='city'
                    size={10}
                    maxLength={100}
                    label='contact.form.cityTownPlaceholder'
                    value={addressObj.city}
                    styleDotted
                    onChange={this._onChangeAdddress.bind(
                      this,
                      addressObj,
                      'city'
                    )}
                  />
                </div>
              </div>
            )}
            <div className='formrow'>
              <div className='formcol'>
                <Select
                  options={countries}
                  name='country'
                  label='contact.form.optionsPlaceholder'
                  multilingualOptions
                  className='form-dropdown'
                  onChange={this._onChangeAdddress.bind(
                    this,
                    addressObj,
                    'country'
                  )}
                  value={
                    addressObj.country
                      ? addressObj.country
                      : this.props.teamCountry
                  }
                />
              </div>
            </div>
          </div>
        )
      })
    }
  }

  _onAddAddress (ev) {
    ev.preventDefault()
    this.data.contact.addresses.push({
      type: this._getDefaultAddressType(),
      street: '',
      streetNumber: '',
      postcode: '',
      city: '',
      country: this.props.teamCountry
    })

    this.setState({ dataDate: new Date() })
  }
}

export default ContactForm
